module.exports = __webpack_public_path__ + "media/images/icon-idea-collection-9f8ddd8553bb510b0702e30df26e8759.svg";